<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="85"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <delegate v-if="showDelegate"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @submitForm="submitForm">
        </delegate>
    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import delegate from '@/components/flow/blacklog/delegate'

    export default {
        name: 'backlog',
        props: ['menuData'],
        components: {
            tableGrid,
            toolBar,
            delegate
        },
        data() {
            return {
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "流程名称",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                formData: {},
                dataList: [],
                loading: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                showDelegate: false,
                dialogLoading: false,

                headList: [
                    {
                        column_name: '_px',
                        column_comment: '序号',
                        column_width: '55'
                    },
                    {
                        column_name: 'PNAME_',
                        column_comment: '流程名称',
                        column_width: '150'
                    },
                    {
                        column_name: 'INITATOR',
                        column_comment: '申请人',
                        column_width: '100',
                    },
                    {
                        column_name: 'ASSIGNEE_',
                        column_comment: '当前节点(审批人)',
                        column_width: '200',
                    },
                    {
                        column_name: 'NAME_',
                        column_comment: '当前任务',
                        column_width: '200',
                    },
                    {
                        column_name: 'CREATE_TIME_',
                        column_comment: '创建时间',
                    },
                    {
                        column_name: "SUSPENSION_STATE_", column_comment: "状态", column_width: "100", type: "tag",
                        info: [{code: '1', name: '正在运行', type: 'success'},
                            {code: '2', name: '已挂起', type: 'info'},]
                    },
                    {
                        column_name: "_opt", column_comment: "操作", column_width: "300", opts: [
                            {method: "info", name: "流程信息", type: "primary", icon: "el-icon-toilet-paper"},
                            {method: "send", name: "委派", type: "warning", icon: "el-icon-s-flag"},
                        ]
                    },
                ],
            }
        },
        mounted() {
            this.getListData() // 初始化表格数据
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/ruprocdef/list",
                    param: {
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.varList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
            },
            async tableOpt(type, data) {
                this.formData = data;
                if(type==="info"){
                    this.$message.info("开发中...")
                }
                else if(type==="send"){
                    this.showDelegate = true;
                }
            },
            async submitForm(form) {
                let param = {
                    url: "/ruprocdef/delegate",
                    param: {
                        ID_:form.ID_,
                        ASSIGNEE_:form.ASSIGNEE_
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode === '0') {
                    this.$message.success("委派成功");
                    this.closeDialog();
                    this.getListData();
                }
            },

            closeDialog() {
                this.showDelegate = false;
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }
    }
</style>